import { cdnRoot } from 'utils/cdn'
import styled from 'styled-components'
import { useIsMounted } from 'hooks/util/useIsMounted'
import { animated, config, useTrail } from '@react-spring/web'

function LoadingSpinner() {
  const mounted = useIsMounted()

  const trail = useTrail(6, {
    config: config.gentle,
    opacity: mounted ? 1 : 0,
    y: mounted ? 0 : 8,
    from: { opacity: 0, y: 8 },
  })

  return (
    <LoadingSpinnerContainer style={trail[0]}>
      <img src={`${cdnRoot}/images/spinner.gif`} />
    </LoadingSpinnerContainer>
  )
}

const LoadingSpinnerContainer = animated(styled.div`
  margin: 32px;
`)

export default LoadingSpinner
